import React, { Component } from "react";
import PropTypes from "prop-types";
import PostFilter from "../PostFilter";
import CASE_TYPES from "../../constants/caseTypes";

class PostCategoryFilter extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.onChange(this.props.value);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.props.value) {
      this.props.onChange(nextProps.value);
    }
  }
  render() {
    let postCategories = CASE_TYPES.filter(({ hidden }) => !hidden).map(({ caseType, index }) => ({
      text: caseType,
      value: index + 1,
    }));

    postCategories = [{ text: "All categories", value: null }, ...postCategories];
    return <PostFilter options={postCategories} {...this.props} />;
  }
}

PostCategoryFilter.propTypes = {
  onChange: PropTypes.func.isRequired,
  clearFilter: PropTypes.func.isRequired,
  value: PropTypes.number,
};

export default PostCategoryFilter;



// WEBPACK FOOTER //
// ./src/components/PostCategoryFilter/index.js